import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { EProductType, UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function loginAsUser(
  userUid: string,
  product: EProductType = EProductType.LEEDPULSE,
  auth: Authentication
): Promise<any> {
  if (
    ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
  ) {
    throw new LoginAsUserFailure('Unauthorized', 'unauthorized');
  }
  try {
    return await HttpClient.post(
      '/auth/backoffice/loginasuser',
      {
        userUid: userUid,
        product: product,
      },
      auth.token
    );
  } catch (e) {
    console.log('error: ', e);
    throw new LoginAsUserFailure();
  }
}

export class LoginAsUserFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default loginAsUser;
